import { render, staticRenderFns } from "./TaxFinishStep.vue?vue&type=template&id=85178fca&"
import script from "./TaxFinishStep.vue?vue&type=script&lang=js&"
export * from "./TaxFinishStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports